<form class="new-proposal__fields new-proposal__fields--client-details">
    <h3 i18n="@@proposals.client_details">Client Details</h3>
    <div class="new-proposal__fields--client-details--existing-client">
        <input class="styled-checkbox large proposal-first-step" type="checkbox" name="existing-client" id="existing-client" [checked]="clientOption == 'existing'" (change)="setClientOption($event.target.checked, 'existing')" />
        <label class="checkbox-label" for="existing-client" i18n="@@common.existing_client">Existing Client</label>
        
        <fieldset [hidden]="clientOption != 'existing'" class="no-label" [ngClass]="{'has-error': submitted && !clientId}">
            <select 
                app-select2
                [options]="{
                    ajax: {url: clientListApi},
                    idColumn: 'id',
                    textColumn: 'full_name'
                }"
                [selected]="selectedClient ? {id: selectedClient.id, text: selectedClient.full_name} : null"
                (itemSelected)="selectClient($event)"
                i18n-data-placeholder="@@option.select_client" data-placeholder="Please type client name" 
                [(ngModel)]="clientId" [ngModelOptions]="{standalone: true}"
            ><option></option>
            </select>
            
            <span class="field-error mt-n2" i18n="@@error.select_client" >Please select client </span>
        </fieldset>
        
    </div>

    <div class="new-proposal__fields--client-details--new-client">
        <input class="styled-checkbox large proposal-first-step" type="checkbox" name="new-client" id="new-client" [checked]="clientOption == 'new'" (change)="setClientOption($event.target.checked, 'new')" />
        <label class="checkbox-label" for="new-client" i18n="@@proposals.new_client">New Client</label>
    </div>


    <form [formGroup]="newClientForm" class="new-proposal__fields--client-details--info" [hidden]="clientOption != 'new'">
        <fieldset class="half" [ngClass]="{'has-error': submitted && newClientForm.get('first_name').errors}">
            <label i18n="@@proposals.first_name">First Name<i class="req-star">*</i></label>
            <input type="text" formControlName="first_name" />
            <span class="field-error" i18n="@@error.required">Required</span>
        </fieldset>

        <fieldset class="half">
            <label i18n="@@proposals.last_name">Last Name</label>
            <input type="text" formControlName="last_name"/>
            <!-- <span class="field-error" i18n="@@error.required">Required</span> -->
        </fieldset>

        <fieldset class="oneThird">
            <label i18n="@@proposals.company">Company</label>
            <input type="text" formControlName="company" />
        </fieldset>

        <fieldset class="oneThird" [ngClass]="{'has-error': submitted && newClientForm.get('phone').errors}">
            <label i18n="@@proposals.phone">Phone</label>
            <input type="text" formControlName="phone" maxlength="10" />
            <span class="field-error"  i18n="@@error.invalid_phone_number">Invalid phone number</span>
        </fieldset>

        <fieldset class="oneThird" [ngClass]="{'has-error': submitted && newClientForm.get('email').errors }">
            <label i18n="@@proposals.email">Email Address</label>
            <input type="text" formControlName="email" />
            <span class="field-error" i18n="@@errors.in_correct_email" *ngIf="newClientForm.get('email').errors">
                {{ newClientForm.get('email').errors.serverError ? newClientForm.get('email').errors.serverError : 'In correct Email' }}
            </span>
        </fieldset>
    </form>

    <div class="new-proposal__controlsBTN">
        <a href="javascript:void(0)" class="tu-btn pink next_btn" (click)="submit()" i18n="@@button.next">Next</a>
    </div>
</form>